import { psAxios } from '@patsnap/common-ps-http';

export interface TrackEvent {
    source_type?: string;
    other_param?: string;
    event_detail_str?: string;
    module_type?: string;
    event_type?: string;
}

export function track(data: TrackEvent): Promise<any> {
    const defaultData = {
        module_type: 'EUREKA',
    };

    return psAxios.post(
        `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/tracking/add`,
        {
            ...defaultData,
            ...data,
        },
        {
            headers: {
                'X-API-VERSION': '1.0',
            },
        },
    ).catch((e) => {
        console.warn('trackApi error: ', e);
    });
};


